import { createApiInstance } from './index';

const api = createApiInstance();

/**
 * 取得專案成員
 * @param {string} userName
 * @param {string} projectUuid
 */
export const getProjectMembersByProjectId = (userName, projectUuid) => {
  return api.post('get_projectmembers_by_pid/', {
    acct_email: userName,
    project_uuid: projectUuid
  });
};

/**
 * 依帳號取得專案列表
 * @param {string} acctUuid
 */
export const getProjectsByAcctId = (acctUuid) => {
    return api.post('get_project_by_acct_id/', {
      acct_uuid: acctUuid,
    });
  };

/**
 * 取得專案角色與成員角色
 * @param {Object} payload
 * @param {string} payload.project_uuid
 * @param {string|null} payload.project_member_uuid
 */
export const getProjectRolesByProjectId = (payload) => {
  return api.post('get_project_roles_by_pid/', payload);
};

/**
 * 依 project_member_id 取得專案成員資料
 * @param {string} projectMemberUuid
 */
export const getProjectMemberByProjectMemberId = (projectMemberUuid) => {
  return api.post('get_projectmember_by_pmid/', {
    project_member_uuid: projectMemberUuid,
  });
};

/**
 * 新增專案成員
 * @param {Object} payload
 * @param {string} payload.project_uuid
 * @param {string} payload.company_member_uuid
 * @param {Array<string>} payload.role_uuid_list
 * @param {string} payload.join_dt
 */
export const createProjectMemberApi = (payload) => {
  return api.post('create_project_member/', payload);
};

/**
 * 更新專案成員角色
 * @param {Object} payload
 * @param {string} payload.project_member_uuid
 * @param {string[]} payload.role_uuid_list
 */
export const updateProjectMemberRole = (payload) => {
  return api.post('update_project_member_role/', payload);
};

/**
 * 取得「尚未加入專案」的公司成員
 * @param {Object} payload
 * @param {string} payload.company_uuid
 * @param {string} payload.project_uuid
 * @param {string|null} payload.search
 */
export const getCompanyMembersNotInProject = (payload) => {
  return api.post("get_company_members_not_in_project/", payload);
};

/**
 * 刪除專案成員
 * @param {Object} payload
 * @param {string} payload.project_member_uuid
 */
export const deleteProjectMember = (payload) => {
  return api.post("delete_project_member/", payload);
};

/**
 * 取得專案權限類型
 */
export const getAuthorityTypes = () => {
  return api.post("get_authority_type/");
};

/**
 * 建立專案角色
 * @param {Object} payload
 * @param {string} payload.project_uuid
 * @param {string} payload.name
 * @param {string} payload.desc
 * @param {string[]} payload.authority_code
 */
export const createProjectRole = (payload) => {
  return api.post("create_project_role/", payload);
};

/**
 * 編輯專案角色
 * @param {Object} payload
 * @param {string} payload.role_uuid
 * @param {string} payload.name
 * @param {string} payload.desc
 * @param {string[]} payload.authority_code
 */
export const editProjectRole = (payload) => {
  return api.post("edit_project_role/", payload);
};

/**
 * 取得專案角色列表
 * @param {string} payload.project_uuid
 */
export const getProjectRoles = (payload) => {
  return api.post("get_project_roles/", payload);
};

/**
 * 變更專案角色狀態（啟用/停用）
 * @param {string} roleUuid
 */
export const changeProjectRoleStatus = (roleUuid) => {
  return api.post("edit_project_role_status/", { role_uuid: roleUuid });
};

/**
 * 編輯專案（修改內容 / 刪除）
 * @param {string} userName
 * @param {string} projectUuid
 * @param {Object} payload
 *  {
 *    name?: string,
 *    owner_member_no?: number,
 *    status?: number
 *  }
 */
export const editProject = (payload) => {
  return api.post('edit_project/', payload);
};

/**
 * 新增專案
 * @param {Object} payload
 *  {
 *    company_id: number,
 *    name?: string,
 *    owner_member_no?: number,
 *  }
 */
export const createProject = (payload) => {
  return api.post('create_project/', payload);
};

/**
 * 取得使用者的專案資訊
 * @param {string} acctEmail
 */
export const getProjectMemberInfo = async (email) => {
  const response = await api.post('get_project_member_info/', {email});
  return response.data;
};


/**
 * 取得專案的文件編號
 * @param {Object} payload
 * @param {string} payload.project_uuid
 * @param {string} payload.acct_email
 */
export const getDocumentInfoList = async (payload) => {
  const response = await api.post('get_document_info_list/', payload);
  return response.data;
};


/**
 * 取得專案的報表列表
 * @param {Object} payload
 * @param {string} payload.project_uuid
 */
export const getReportList = async (payload) => {
  const response = await api.post('get_report_list/', payload);
  return response.data;
};

/**
 * 新增文件
 * @param {Object} payload
 * @param {string} payload.acct_email
 * @param {Object} payload.report_doc_info - 整包 ReportDocInfo
 */
export const createDocumentInfo = async (payload) => {
  const response = await api.post('create_document_info/', payload);
  return response.data;
};

/**
 * 編輯文件
 */
export const updateDocumentInfo = async (payload) => {
  const response = await api.post('update_document_info/', payload);
  return response.data;
};

/**
 * 刪除文件
 */
export const deleteDocumentInfo = async (payload) => {
  const response = await api.post('delete_document_info/', payload);
  return response.data;
};